export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6cc999a20c75f53d396b2b72ef56584a.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 flex flex-col items-center">
        {/* Badge */}
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 text-white/80 text-xs uppercase tracking-widest font-medium mb-8">
          <i className="ri-apple-fill text-sm" />
          iOS Platform Specialists
        </span>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight max-w-4xl tracking-tight" style={{ fontFamily: "'Inter', sans-serif" }}>
          Modern Applications
          <br />
          <span className="text-white/70">for iOS Platform</span>
        </h1>

        {/* Subtitle */}
        <p className="mt-6 text-lg md:text-xl text-white/60 max-w-xl leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
          A team of experts building premium security and performance
          tools that redefine the mobile experience.
        </p>

        {/* Company name badge */}
        <div className="mt-10 flex items-center gap-2 text-white/40 text-sm tracking-widest uppercase">
          <span className="w-8 h-px bg-white/30" />
          ROXTVEL d.o.o. Pirot
          <span className="w-8 h-px bg-white/30" />
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/30 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}
